import React from "react";
import images from "../../images";
import { useTranslation } from "react-i18next";

function QRScan() {
  const { t } = useTranslation();

  return (
    <div className="flex overflow-hidden flex-col items-center pt-14 mx-auto w-full bg-amber-50 max-w-[480px]">
      <div className="flex flex-col items-center mt-6 w-full text-center max-w-[328px]">
        <img
          loading="lazy"
          src={images.LogoLogin}
          className="object-contain w-20 aspect-[1.36]"
          alt="User's Camera Logo"
        />
        <div className="flex flex-col w-full">
          <div className="flex flex-col items-center w-full">
            <h1 className="text-4xl font-bold text-black">
              {" "}
              {t("qrScan.userCamera")}
            </h1>
            <div className="gap-2.5 self-stretch px-3 py-1.5 mt-2.5 text-xs leading-none text-black bg-yellow-50 rounded-xl">
              {t("qrScan.consumerAccount")}
            </div>
          </div>
        </div>
      </div>
      <div className="flex relative flex-col justify-center items-center self-stretch px-8 py-52 mt-7 w-full min-h-[679px] rounded-[30px_30px_0px_0px] shadow-[0px_0px_4px_rgba(0,0,0,0.08)]">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/8d66c08d0ed97039b5d8a6b7f305368490a8ded4c35880cc2836338f5d45e01c?placeholderIfAbsent=true&apiKey=e1e8f94c02f94b14a3c45dc97123a02f"
          className="object-cover absolute inset-0 size-full"
          alt="Camera View"
        />
        <div className="flex relative flex-col  max-w-full rounded-none w-[275px]">
          <img src={images.QRScanImage} alt="" />
        </div>
      </div>
    </div>
  );
}

export default QRScan;
